import React, { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Nav, Container, Card } from "react-bootstrap";
// The component you provided
import SalesOrderLog from "./ServiceLog";

import SalesOrderDraft from "./ServiceDraft";

// Define the valid tab types
type TabType = "log" | "junk" | "draft";

// Map the URL param to a more readable type for the component
const tabMap: Record<string, TabType> = {
  enquiry_log: "log",
  junk: "junk",
  draft: "draft",
};

const SalesOrderServicePage: React.FC = () => {
  // Use useParams to get the 'tab' dynamic segment from the route
  const { tab: urlTabParam } = useParams<{ tab: string }>();
  const type: "service" = "service"; // The type is fixed for this page

  // Determine the active tab based on the URL param
  const activeTab: TabType = tabMap[urlTabParam || "sales_order_log"] || "log";

  


  // Determine which component to render
  const TabContent = useMemo(() => {
    // Pass the fixed 'type' prop to all tab components
    switch (activeTab) {
      case "log":
        return <SalesOrderLog type={type} />;
      case "draft":
        return <SalesOrderDraft type={type} />;
      default:
        // Render the log page as default/fallback
        return <SalesOrderLog type={type} />;
    }
  }, [activeTab]);

  return (<>
  {TabContent}
  </>
 
  );
};

export default SalesOrderServicePage;
